import React from "react";
import { ReactComponent as CurtainsSvg } from "../svg/curtains.svg";

export default function CurtainsIcon({ size = 64, color = "#32363F", ...props }) {
  return <CurtainsSvg width={size} height={size} style={{ color }} {...props} />;
}
